<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <form [formGroup]="formGroup">
          <div class="row">
            <div class="col-xs-12 col-md-9 input-trend-search">
              <input
                type="search"
                #searchBox
                class="form-control"
                [placeholder]="'category.list.search' | translate"
                formControlName="search"
                (keyup)="search(searchBox.value)"
              />
              <span class="mdi mdi-magnify search-icon ml-2"></span>
            </div>

            <div class="col-xs-12 col-md-3 btn-group trend-button">
              <button class="btn btn-info fw-bold" (click)="add()">
                {{ 'category.list.add' | translate }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div class="card">
  @if (pager.total == 0) {
    <empty-records-component
      [message]="'category.list.emptyMessage' | translate"
      [subMessage]="'category.list.emptySubMessage' | translate"
      [labelButton]="'category.list.add' | translate"
      [icon]="'mdi mdi-alert-circle-outline'"
      (emitEvent)="add()"
    />
  }

  @if (pager.total > 0) {
    <div class="card-body table-responsive">
      <table class="table table-hover table-centered mb-0">
        <thead>
          <tr>
            <th class="text-primary-emphasis">{{ 'category.list.columnType' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'category.list.columnName' | translate }}</th>
            <th><span class="sr-only"></span></th>
          </tr>
        </thead>
        <tbody>
          @for (item of pager.list; track $index) {
            <tr>
              <td>
                {{ item.type === typeCategory ? ('category.list.fastResponse' | translate) : "-" }}
              </td>
              <td>{{ item.name }}</td>
              <td>
                <div class="d-flex justify-content-end">
                  <button
                    type="button"
                    class="btn btn-dropdown-list"
                    [matMenuTriggerFor]="menu"
                  >
                    <i class="mdi mdi-dots-vertical text-primary-emphasis"></i>
                  </button>

                  <mat-menu #menu="matMenu">
                    <button mat-menu-item tabindex="0" (click)="edit(item)">
                      {{ 'category.list.edit' | translate }}
                    </button>
                    <button mat-menu-item tabindex="0" (click)="delete(item)">
                      {{ 'category.list.remove' | translate }}
                    </button>
                  </mat-menu>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
      @if (pager.total > pager.perPage) {
        <paginator [pager]="pager" (onPager)="loadPage($event)" />
      }
    </div>
  }
</div>
